import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 place-items-center sm:p-4 h-full" }
const _hoisted_2 = { class: "flex flex-col sm:w-3/4 w-full gap-4" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:items-center justify-between gap-4" }
const _hoisted_4 = { class: "text-xl font-semibold" }
const _hoisted_5 = { class: "flex flex-col rounded-md shadow-lg overflow-auto gap-4" }
const _hoisted_6 = { class: "border-collapse mt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", { class: "" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 py-4 text-left font-semibold border-b border-gray-300" }, " N° Alerta "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 py-4 text-center font-semibold border-b border-gray-300" }, " Fecha de envío "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 py-4 text-center font-semibold border-b border-gray-300" }, " Descripción "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 py-4 text-center font-semibold border-b border-gray-300" }, " Acciones ")
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "px-8 py-4 text-center font-gray-800" }
const _hoisted_10 = { class: "px-8 py-4 text-center font-gray-800" }
const _hoisted_11 = { class: "px-8 py-4 text-center font-gray-800" }
const _hoisted_12 = { class: "line-clamp-1" }
const _hoisted_13 = { class: "px-8 py-4 flex flex-row flex-wrap gap-4 justify-center items-center h-full" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  colspan: "4",
  scope: "col",
  class: "text-center text-gray-500 p-8"
}
const _hoisted_16 = { class: "flex flex-row items-center justify-center gap-2 w-full" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Aun no hay alertas asignadas.", -1)

import { watch, ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import useInvestmentContractAlertsStore from "@/stores/investment-contract-alerts";

import PaginationControl from "@/components/atoms/PaginationControl.vue";
import NewAlertModal from "@/components/organisms/NewAlertModal.vue";
import ShowAlertModal from "@/components/organisms/ShowAlertModal.vue";
import EditAlertModal from "@/components/organisms/EditAlertModal.vue";

import Swal from "sweetalert2";
import { reformatDate } from "@/services/utils";
import { Response, ResponsePagination } from "@/services/types";
import { InvestmentContractAlert } from "@/services/invest/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'InvestmentContractAlertsView',
  setup(__props) {

const route = useRoute();
const contractId = ref(+route.params.id);

const newAlertModal = ref<boolean>(false);

const selectedAlertId = ref<number>(0);
const showAlertData = ref<InvestmentContractAlert>();
const editAlertModal = ref<boolean>(false);
const showAlertModal = ref<boolean>(false);

const alertStore = useInvestmentContractAlertsStore();
const {
  alertList,
  pagination,
  fetchAlertsResponse,
  fetchAlertResponse,

  formIsValid,

  createResponse,

  updateResponse,

  deleteResponse,
}: {
  alertList: InvestmentContractAlert[];
  pagination: any;
  fetchAlertsResponse: ResponsePagination<InvestmentContractAlert[]>;
  fetchAlertResponse: Response<InvestmentContractAlert>;
  formIsValid: boolean;
  createResponse: Response<void>;
  updateResponse: Response<void>;
  deleteResponse: Response<void>;
} = storeToRefs(alertStore);

const handleDeleteAlert = async (alertId: number) => {
  Swal.fire({
    title: `¿Estás seguro de eliminar la alerta N° ${alertId}?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Eliminar",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      alertStore.deleteAlert(alertId, contractId.value);
    }
  });
};

const handleSetPage = async (page: number) => {
  pagination.value.page = page;
  await alertStore.fetchAlerts(contractId.value);
};

onMounted(() => {
  alertStore.fetchAlerts(contractId.value);
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, " Alertas de contrato N° " + _toDisplayString(contractId.value), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = () => (newAlertModal.value = true)),
          class: "flex flex-row items-center px-4 py-2 rounded-full bg-green-700 shadow-lg text-white justify-center font-medium text-sm hover:scale-110 transition-all"
        }, " Agregar nueva alerta ")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          (_unref(alertList) && _unref(alertList).length > 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alertList), (alert) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: alert.id
                  }, [
                    _createElementVNode("td", _hoisted_9, _toDisplayString(alert.id), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(alert.shipmentDate
                    ? _unref(reformatDate)(`${alert.shipmentDate}`)
                    : "-"), 1),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(alert.description || alert.description != ""
                      ? alert.description
                      : "-"), 1)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createVNode(_component_mdicon, {
                        class: "hover:cursor-pointer hover:scale-105 transition-all",
                        onClick: 
                    () => {
                      selectedAlertId.value = alert.id;
                      editAlertModal.value = true;
                    }
                  ,
                        name: "pencil"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_mdicon, {
                        class: "hover:cursor-pointer hover:scale-105 transition-all",
                        onClick: 
                    () => {
                      selectedAlertId.value = alert.id;
                      showAlertData.value = alert;
                      showAlertModal.value = true;
                    }
                  ,
                        name: "eye"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_mdicon, {
                        class: "hover:cursor-pointer hover:scale-105 transition-all",
                        onClick: ($event: any) => (handleDeleteAlert(alert.id)),
                        name: "delete"
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_mdicon, { name: "information" }),
                      _hoisted_17
                    ])
                  ])
                ])
              ]))
        ])
      ]),
      _createVNode(PaginationControl, {
        selectedPage: _unref(pagination).page,
        perPage: _unref(pagination).per_page,
        totalPages: _unref(pagination).total_pages || 1,
        onSetPage: handleSetPage
      }, null, 8, ["selectedPage", "perPage", "totalPages"])
    ]),
    _createVNode(NewAlertModal, {
      visible: newAlertModal.value,
      "contract-id": contractId.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = () => (newAlertModal.value = !newAlertModal.value))
    }, null, 8, ["visible", "contract-id"]),
    _createVNode(ShowAlertModal, {
      visible: showAlertModal.value,
      "alert-data": showAlertData.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = () => (showAlertModal.value = !showAlertModal.value))
    }, null, 8, ["visible", "alert-data"]),
    _createVNode(EditAlertModal, {
      visible: editAlertModal.value,
      "contract-id": contractId.value,
      "alert-id": selectedAlertId.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = () => (editAlertModal.value = !editAlertModal.value))
    }, null, 8, ["visible", "contract-id", "alert-id"])
  ]))
}
}

})